import OfferCard, { CardRenderableOffer } from './card';
import cardGrid from '../../styles/card-grid.module.css';

interface Props {
  offers: (CardRenderableOffer & { id: string | number })[];
  reload: () => void;
}

/**
 * Renders a list of offers in a grid. Does not handle empty states.
 */
const OfferGrid: React.FC<Props> = ({ offers, reload }) => (
  <div className={cardGrid.cardGrid}>
    {offers.map(offer => (
      <OfferCard offer={offer} key={offer.id} onDelete={reload} onEdit={reload} />
    ))}
  </div>
);

export default OfferGrid;
